import logo1 from "../../Assets/logobgremove.png";
import { Form } from "react-bootstrap";
import { GoEye, GoEyeClosed } from "react-icons/go";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UseFormValidations } from "../../FormValidation/UseFormValidations";
import "./Auth.css";
import { forgetPassword } from "../../Config/ValidationSchema";
import { notify, save } from "../../Config/SharedFunctions";
import { urls } from "../../Config/Consts"; 
import { IoIosArrowRoundForward } from "react-icons/io";
 
function ForgotPassword() {
  const navigate = useNavigate();
  const { token } = useParams();
  const [type1, setType1] = useState("password");
  const [type2, setType2] = useState("password");

  const isPasswordComplex = (password) => {
     const capitalLetterRegex = /[A-Z]/;
    const smallLetterRegex = /[a-z]/;
    const specialCharacterRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
    const numberRegex = /[0-9]/;
     return (
      password.length >= 6 &&
      capitalLetterRegex.test(password) &&
      smallLetterRegex.test(password) &&
      specialCharacterRegex.test(password) &&
      numberRegex.test(password)
    );
  };
  

  const submit = async () => {
    if (data?.password === data?.confirmPassword) {
       if (!isPasswordComplex(data?.password)) {
        notify(false, "Password must contain at least one capital letter, one small letter, one special character, one number, and have a length greater than 6 characters.");
        return;
      }
      let body = { token: token, password: data?.password };
      let res = await save(urls.Auth.CreatePassword, body);
      if (res?.data?.status === true) {
        navigate("/");
      }
    } else {
      notify(false, "Password and confirm password should be the same");
    }
  };

  const { data, errors, handleSubmit, formChange } = UseFormValidations({
    validationSchema: forgetPassword,
    submit: submit,
  });

  return (
    <section className="keka-login-section">
      <div className="keka-login-row">
        {/* Left Panel - Illustration banner */}
        <div className="keka-left-panel"></div>

        {/* Right Panel - Form Card */}
        <div className="keka-right-panel">
          <div className="keka-login-card">
            {/* Logo */}
            <div className="keka-logo-container">
              <img src={logo1} alt="Logo" className="keka-logo" />
            </div>

            <h2>Create New Password</h2>
            <p className="subtitle">Please enter your new password below</p>

            <Form id="login-form" onSubmit={handleSubmit}>
              {/* Password Field */}
              <div className="keka-input-group">
                <label className="keka-form-label" htmlFor="password">Password</label>
                <div className="keka-password-wrapper">
                  <Form.Control
                    type={type1}
                    required
                    id="password"
                    name="password"
                    className="keka-input-field"
                    placeholder="Enter password"
                    onChange={formChange("")}
                    isInvalid={!!(errors && errors?.password)}
                  />
                  <button
                    type="button"
                    className="keka-eye-btn"
                    onClick={() => setType1(type1 === "password" ? "text" : "password")}
                    aria-label={type1 === "password" ? "Show password" : "Hide password"}
                  >
                    {type1 === "password" ? <GoEyeClosed /> : <GoEye />}
                  </button>
                </div>
                {errors && errors?.password && (
                  <Form.Control.Feedback type="invalid" style={{ display: 'block', textAlign: 'left', marginTop: '0.25rem' }}>
                    {errors?.password}
                  </Form.Control.Feedback>
                )}
              </div>

              {/* Confirm Password Field */}
              <div className="keka-input-group">
                <label className="keka-form-label" htmlFor="confirmPassword">Confirm Password</label>
                <div className="keka-password-wrapper">
                  <Form.Control
                    type={type2}
                    name="confirmPassword"
                    required
                    id="confirmPassword"
                    placeholder="Confirm your password"
                    className="keka-input-field"
                    onChange={formChange("")}
                    isInvalid={!!(errors && errors?.confirmPassword)}
                  />
                  <button
                    type="button"
                    className="keka-eye-btn"
                    onClick={() => setType2(type2 === "password" ? "text" : "password")}
                    aria-label={type2 === "password" ? "Show password" : "Hide password"}
                  >
                    {type2 === "password" ? <GoEyeClosed /> : <GoEye />}
                  </button>
                </div>
                {errors && errors?.confirmPassword && (
                  <Form.Control.Feedback type="invalid" style={{ display: 'block', textAlign: 'left', marginTop: '0.25rem' }}>
                    {errors?.confirmPassword}
                  </Form.Control.Feedback>
                )}
              </div>

              {/* Save Button */}
              <button
                type="submit"
                onClick={handleSubmit}
                className="keka-btn-primary"
                style={{ marginTop: '1rem' }}
              >
                <span>Save Password</span>
                <IoIosArrowRoundForward size={25} />
              </button>
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ForgotPassword;
